import { KendoBaseComponent, KendoBaseInputComponent } from '@progress/kendo-base-components-vue-wrapper'
import SliderProps from './SliderProps'

import Tooltip from '../Common/Tooltip'

export default {
    props: SliderProps,
    mixins: [
        KendoBaseComponent,
        KendoBaseInputComponent,
        Tooltip
    ],
    mounted() {
        var that = this
        kendo.jQuery(that.$el).kendoSlider(that.widgetOptions)

        that.$emit('kendowidgetready', that.kendoWidget())

        that.kendoWidget().bind('change', function(){
            that.$emit('changemodel', that.$refs.valueInput.value)
        })

        that.kendoWidget().bind('slide', function(){
            that.$emit('changemodel', that.$refs.valueInput.value)
        })
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoSlider()
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoSlider/KendoSliderMixin.js